import axios from "axios";

// base URL to make requests to the movie database
const instance = axios.create({
    baseURL: "http://api.themoviedb.org/3",
    // baseURL: "https://api.themoviedb.org/3", is the API (cloud function) URL
});

export default instance;